import { render } from "./IncidentHeroCards.vue?vue&type=template&id=9248c7a4"
import script from "./IncidentHeroCards.vue?vue&type=script&lang=js"
export * from "./IncidentHeroCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__